export const isVideo = (url) => {
  const videoExtensions = ["mp4", "webm", "ogg"];
  const extension = url?.split(".")?.pop();
  return videoExtensions?.includes(extension);
};

export const isVideoSelected = (file) => {
  if (file instanceof File) {
    return file?.type?.startsWith("video/");
  }
  return false;
};
